import { t } from '@lingui/macro'

import { CareQuestionFlowProvider } from './context/CareQuestion.context'
import { CareQuestionRootPage } from './pages/CareQuestionRoot.page'
import { EmergencyPage } from './pages/emergency/emergency.page'
import { ContactPage } from './pages/patient-communication-flow/Contact.page'
import { PatientCommunicationFlow } from './pages/patient-communication-flow/PatientCommunicationFlow'
import { DoctorStep } from './pages/patient-communication-flow/steps/DoctorStep'
import { QuestionStep } from './pages/patient-communication-flow/steps/QuestionStep'
import { SuccessStep } from './pages/patient-communication-flow/steps/SuccessStep'
import { TypeSelectPage } from './pages/patient-communication-flow/TypeSelect.page'
import { CareQuestionFlowBlockedPage } from './pages/question/care-question-flow-blocked/CareQuestionFlowBlocked.page'
import { ComingSoonPage } from './pages/question/coming-soon/ComingSoon.page'

import type { RouteObject } from 'react-router-dom'
import type { ESignDoctor } from '../appointment/types/e-sign.types'

const careQuestionRoutes: RouteObject[] = [
  {
    path: 'care-question',
    element: <CareQuestionRootPage />,
    children: [
      // Emergency page
      {
        path: 'emergency',
        element: <EmergencyPage />,
      },
      // Contact page
      {
        path: 'contact',
        element: <ContactPage />,
      },
      // Question type select
      {
        path: 'question',
        element: <TypeSelectPage />,
      },
      // App question
      {
        path: 'app-question',
        element: (
          <CareQuestionFlowProvider requireSpecialisations={false}>
            <PatientCommunicationFlow
              title={t({
                id: 'patient-communication.app-question',
                message: 'Vraag over de app',
              })}
              category={t({
                id: 'patient-communication.app-question',
                message: 'Vraag over de app',
              })}
              receiverType={'hospital'}
              steps={[
                {
                  hideProgressBar: false,
                  content: (onNext, onPrevious, header, progress) => (
                    <QuestionStep
                      header={header}
                      progress={progress}
                      onNext={(message: string) => onNext({ message })}
                    />
                  ),
                },
              ]}
              submittedScreen={<SuccessStep />}
            />
          </CareQuestionFlowProvider>
        ),
      },
      // Care Program question
      {
        path: 'care-program-question',
        element: (
          <CareQuestionFlowProvider>
            <PatientCommunicationFlow
              title={t({
                id: 'patient-communication.care-program-question',
                message: 'Vraag aanbod zorgprogramma',
              })}
              category={t({
                id: 'patient-communication.care-program-question',
                message: 'Vraag aanbod zorgprogramma',
              })}
              receiverType={'hospital'}
              steps={[
                {
                  hideProgressBar: false,
                  content: (onNext, onPrevious, header, progress) => (
                    <QuestionStep
                      header={header}
                      progress={progress}
                      title={t({
                        id: 'care-question.question-flow.title',
                        message: 'Ik heb een vraag',
                      })}
                      description={t({
                        id: 'care-question.question-flow.description',
                        message: 'Omschrijf welke gezondheidsnoden je hebt waarbij we je kunnen ondersteunen.',
                      })}
                      onNext={(message: string) => onNext({ message })}
                    />
                  ),
                },
              ]}
              submittedScreen={<SuccessStep />}
            />
          </CareQuestionFlowProvider>
        ),
      },
      // Medical question
      {
        path: 'medical-question',
        element: (
          <CareQuestionFlowProvider>
            <PatientCommunicationFlow
              title={t({
                id: 'patient-communication.medical-question',
                message: 'Medische vraag',
              })}
              category={t({
                id: 'patient-communication.medical-question',
                message: 'Medische vraag',
              })}
              receiverType={'hospital'}
              steps={[
                {
                  hideProgressBar: false,
                  content: (onNext, onPrevious, header, progress) => (
                    <DoctorStep
                      header={header}
                      progress={progress}
                      onNext={(doctor: ESignDoctor) => onNext({ doctor })}
                    />
                  ),
                },
                {
                  hideProgressBar: false,
                  content: (onNext, onPrevious, header, progress) => (
                    <QuestionStep
                      header={header}
                      progress={progress}
                      onNext={(message: string) => onNext({ message })}
                    />
                  ),
                },
              ]}
              submittedScreen={<SuccessStep />}
            />
          </CareQuestionFlowProvider>
        ),
      },
      // Blocked question
      {
        path: 'blocked-question',
        element: <CareQuestionFlowBlockedPage />,
      },
      // Coming Soon
      {
        path: 'coming-soon',
        element: <ComingSoonPage />,
      },
    ],
  },
]

export { careQuestionRoutes }
